import { render } from '../../core/shell.js';
import { S, save } from '../../core/store.js';
import { $ } from '../../core/util.js';
import { vBoard } from './view.js';
import { actions, changes } from './actions.js';

// Cashflow assumption fields: data-chg="fin-<field>"
const fin = {};
['cash', 'delay', 'rent', 'software', 'insurance', 'gear', 'basAmt', 'newWork'].forEach((f) => {
  fin['fin-' + f] = (el) => { S.fin[f] = Number(el.value) || 0; save(); render(); };
});
fin['fin-basDue'] = (el) => { if (el.value) { S.fin.basDue = el.value; save(); render(); } };
fin['fin-incPipeline'] = (el) => { S.fin.incPipeline = el.checked; save(); render(); };

export default {
  id: 'board', label: 'Boardroom', icon: 'chart', nav: true,
  show: (u) => u.role === 'admin',
  view: vBoard, actions,
  changes: { ...changes, ...fin },
  init() { $('#fc').addEventListener('change', (e) => changes.ctfile(e.target)); }
};
